import countriesJSON from "./countries.json";

export type Country = {
    name: string;
    originalName: string;
    iso2: string;
    dialCode: string;
};

export const otherCountry: Country = {
    name: "Other Country",
    originalName: "Other Country",
    iso2: "other",
    dialCode: ""
};

export const countriesData: Country[] = countriesJSON.map((country) => ({
    name: country.name,
    originalName: country.originalName,
    iso2: country.iso2,
    dialCode: country.dialCode
}));
